import axios from '@/common/axios'

function baseUrl(locationId) {
  return `/api/gmb/locations/${locationId}/media`
}

export function getMedia(locationId, params) {
  return axios.get(baseUrl(locationId), { params })
}

export function getMediaItem(locationId, mediaId) {
  return axios.get(`${baseUrl(locationId)}/${mediaId}`)
}

export function createMedia(locationId, formData) {
  return axios.post(baseUrl(locationId), formData)
}

export function updateMedia(locationId, mediaId, data) {
  return axios.patch(`${baseUrl(locationId)}/${mediaId}`, data)
}

export function getMediaStats(locationId) {
  return axios.get(`${baseUrl(locationId)}/stats`)
}

export function deleteMedia(locationId, mediaId) {
  return axios.delete(`${baseUrl(locationId)}/${mediaId}`)
}

export function getVideoUploadUrl(locationId, filename) {
  return axios.get(`${baseUrl(locationId)}/video_upload_url`, { params: { filename } })
}
